import { createUseStyles } from 'react-jss'
import { tabletDown } from '../../styles/const/breakpoints'
import { fontWeightRegular } from '../../styles/typography'
import { smallPageMaxWidth } from '../../styles/common'

const useStyles = createUseStyles({
  page: {
    margin: '0 auto',
    paddingTop: 50
  },
  settingsPage: {
    display: 'flex'
  },
  settingsContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    flexBasis: 'content',
    flexGrow: 1,
    padding: '0 25px',
    maxWidth: smallPageMaxWidth,
    width: '100%',
    margin: '0px auto'
  },
  title: {
    fontSize: 24,
    fontWeight: fontWeightRegular
  },
  navContainer: {
    paddingRight: 40,
    maxWidth: 370,
    flexBasis: 370,
    minHeight: '100vh'
  },
  [`@media screen and (${tabletDown})`]: {
    navContainer: {
      maxWidth: '100%',
      flexBasis: '100%',
      borderRight: 'none',
      paddingRight: 0,
      transition: 'all ease 500ms',
      minHeight: 'unset',

      '&.swiped': {
        transform: 'translateX(-110%)'
      }
    },
    settingsContent: {
      padding: 0
    }
  }
})

export default useStyles
